import React, { Component } from 'react';
import { Container, Col, Row } from 'react-bootstrap';
import '../css/Scheduler.css'
import apiRequests from './api-helpers/ApiRequests'
import { ReactComponent as TicketIcon } from '../svg/ticket.svg'
import { useSelector, useDispatch } from 'react-redux'
import { addNotifications } from './redux/notificationSlice'
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import Cookies from 'js-cookie';
class Scheduler extends Component {

    constructor(props) {
        super(props);
        this.state =
        {
            today: new Date(),
            selectedItemNumber: "",
            timeWindows: null,
            Stuffs: [],
            selectedStaff: ""
        }
        this.onClickTimeItem = this.onClickTimeItem.bind(this);
        this.loadTimeWindows = this.loadTimeWindows.bind(this);
        this.loadTimeWindowsCallback = this.loadTimeWindowsCallback.bind(this);
        this.checkWindowAvability = this.checkWindowAvability.bind(this);
        this.loadSelectControls = this.loadSelectControls.bind(this);
        this.loadSelectStuffsControlsCallback = this.loadSelectStuffsControlsCallback.bind(this);
        this.handleChangeSelect = this.handleChangeSelect.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.setStuff !== this.props.setStuff) {
            this.setState({
                Stuffs: "",
            });  
        }
        if (this.props.Contractor && ((prevProps.Contractor ? prevProps.Contractor.value : "") != this.props.Contractor.value)) {
            this.props.onCustomSelectChange({ value: null }, "EntryStartTime");
            this.props.onCustomSelectChange({ value: null }, "EntryStopTime");
            this.setState({ selectedItemNumber: "", timeWindows: null }, () =>
            {
                this.loadTimeWindows();
            });
            this.loadSelectControls();
        }   
    }

    loadTimeWindows() {
        if (this.props.Contractor) {
            let currentGate = this.props.Contractor.Gate;
            let params =
            {
                Gate: currentGate.id + "#" + currentGate.name,
                Date: this.props.currenSelectedDate
            };
            apiRequests.getDataByUrlWithParam('webconapi/GetTimeWindows', params, this.loadTimeWindowsCallback);
        }
    }

    loadTimeWindowsCallback(result) {
        this.setState({ timeWindows: result });
    }

    onClickTimeItem(event) {
        let currentDay = this.props.currenSelectedDate;
        let windownumber = event.currentTarget.attributes['windownumber'].value;
        let nextDay = new Date(currentDay + " 04:00");
        nextDay.setDate(nextDay.getDate() + 1);
        nextDay = nextDay.toISOString().substring(0, 10) + "T00:00";
        let starttime = currentDay.substring(0, 10) + event.currentTarget.attributes['starttime'].value;
        let stoptime = windownumber == "12" ? nextDay : currentDay.substring(0, 10) + event.currentTarget.attributes['stoptime'].value;
        this.props.onCustomSelectChange({ value: starttime }, "EntryStartTime");
        this.props.onCustomSelectChange({ value: stoptime }, "EntryStopTime");
        this.setState({ selectedItemNumber: event.currentTarget.attributes['windownumber'].value });
    }

    checkWindowAvability() {
        let tW = this.state.timeWindows;
        let result = [];
        const currentDateTime = new Date();
        if (tW) {
            for (let i = 1, h = 0; i <= 12; i++, h = h + 2) {
                let hour = ('0' + h).slice(-2)
                let windowItem = { WindowIndex: i, WindowStartTime: this.props.currenSelectedDate + "T" + hour + ":00:00", Count: tW.AvailableNotificationsCount };
                let w = tW.TimeWindows.find(w => w.WindowTimeStart == windowItem.WindowStartTime);
                windowItem.Count = w ? w.FreeNotificationsCount : tW.AvailableNotificationsCount;
                let windowStopTime = new Date(windowItem.WindowStartTime).setHours(h + 2);
                windowItem.IsLocked = (windowStopTime <= currentDateTime) || (windowItem.Count <= 0);
                result.push(windowItem);
            }
            return result;
        }
        else {
            return null;
        }
    }

    ////////////////////////////////////////////////
    //
    // Load Products
    //
    ////////////////////////////////////////////////
    loadSelectControls() {
        this.setState({
            selectedStaff: null
        });
        let params =
        {
            DataInHttpResponse: true,
            SearchParams: [
                { Name: "size", Value: "10000000" },
                { Name: "ExtCompanyId", Value: this.props.CompanyWorkflowId + "X" },
                { Name: "DId", Value: "0X" },
                { Name: "ID_kontrahenci", Value: this.props.Contractor.Id + "X" }   
            ],
            Language: Cookies.get('UserCulture')
        };
        apiRequests.getDataByUrlWithParam('webconapi/GetStuffsItems', params, this.loadSelectStuffsControlsCallback);
    }

    loadSelectStuffsControlsCallback(Stuffs) {
        console.log('MERCHENDISE: ----')
        console.log(Stuffs)
        this.setState((prevState) => ({
            Stuffs
        })); 
    }

    handleChangeSelect(option, label) {
        this.state.Stuffs.find(s => s.value === this.props.setStuff);
        this.setState({
            selectedStaff: option
        });
        this.props.setStuff(option, label);
    }
    render() {
        let contractor = this.props.Contractor;
        let wAv = this.checkWindowAvability();

        return (
            <div className={"d-flex flex-column h-100 m-0 p-0 " + (contractor ? "" : " invisible")}>
                <div className="d-flex flex-column field">
                    <label htmlFor="stuff" className="form-label m-0 p-0"><sup className="text-danger">*</sup>{this.props.t('scheduler.merchendise')}</label>
                    <Select 
                        className="form-control m-0 border-0 p-0"
                        placeholder="Wybierz..."
                        noOptionsMessage={() => ("Nie znaleziono wartości") }
                        options={ this.state.Stuffs }
                        onChange={(selectedOption) => this.handleChangeSelect( selectedOption, "Stuff" ) }
                        value={ this.state.selectedStaff }
                    />
                    <span className="text-danger">{this.props.StuffErrors ? this.props.StuffErrors : ""}</span>
                </div>
                <div className="d-flex flex-column">
                    <label className="form-label m-0  p-0">{this.props.t('scheduler.gate')}</label>
                    <input type="text" className="form-control" value={contractor ? contractor.Gate.name : "--"} readOnly />
                </div>
                <div className="d-flex flex-column border-bottom mt-3">
                    <label className="form-label m-0  p-0"><sup className="text-danger">*</sup>{this.props.t('scheduler.hourOfEntry')}</label>
                    <span className="text-danger">{this.props.EntryStartTimeErrors ? this.props.EntryStartTimeErrors : ""}</span>
                </div>
                <div className="d-flex flex-fill">
                    <div className={"d-flex flex-fill justify-content-center " + (this.state.selectedItemNumber == "1" ? "scheduler-item-selected" : "scheduler-item") + (wAv && (wAv[0].IsLocked == false) ? "" : " scheduler-item-locked")} onClick={this.onClickTimeItem} windownumber="1" starttime="T00:00" stoptime="T02:00">
                        <div className="py-5 d-flex flex-column justify-content-center">
                            <div className="scheduler-item-time-text">00:00-02:00</div>
                            <div className={"scheduler-item-counter " + (wAv && (wAv[0].IsLocked == false) ? "" : " d-none")}>
                                <TicketIcon className="" />
                                <span className="scheduler-item-counter-text">{wAv ? wAv[0].Count : "-"}</span>
                            </div>
                        </div>
                    </div>
                    <div className={"d-flex flex-fill justify-content-center " + (this.state.selectedItemNumber == "2" ? "scheduler-item-selected" : "scheduler-item") + (wAv && (wAv[1].IsLocked == false) ? "" : " scheduler-item-locked")} onClick={this.onClickTimeItem} windownumber="2" starttime="T02:00" stoptime="T04:00">
                        <div className="py-5 d-flex flex-column justify-content-center">
                            <div className="scheduler-item-time-text">02:00-04:00</div>
                            <div className={"scheduler-item-counter " + (wAv && (wAv[1].IsLocked == false) ? "" : " d-none")}>
                                <TicketIcon className="" />
                                <span className="scheduler-item-counter-text">{wAv ? wAv[1].Count : "-"}</span>
                            </div>
                        </div>
                    </div>
                    <div className={"d-flex flex-fill justify-content-center " + (this.state.selectedItemNumber == "3" ? "scheduler-item-selected" : "scheduler-item") + (wAv && (wAv[2].IsLocked == false) ? "" : " scheduler-item-locked")} onClick={this.onClickTimeItem} windownumber="3" starttime="T04:00" stoptime="T06:00">
                        <div className="py-5 d-flex flex-column justify-content-center">
                            <div className="scheduler-item-time-text">04:00-06:00</div>
                            <div className={"scheduler-item-counter " + (wAv && (wAv[2].IsLocked == false) ? "" : " d-none")}>
                                <TicketIcon className="" />
                                <span className="scheduler-item-counter-text">{wAv ? wAv[2].Count : "-"}</span>
                            </div>
                        </div>
                    </div>
                    <div className={"d-flex flex-fill justify-content-center " + (this.state.selectedItemNumber == "4" ? "scheduler-item-selected" : "scheduler-item") + (wAv && (wAv[3].IsLocked == false) ? "" : " scheduler-item-locked")} onClick={this.onClickTimeItem} windownumber="4" starttime="T06:00" stoptime="T08:00">
                        <div className="py-5 d-flex flex-column justify-content-center">
                            <div className="scheduler-item-time-text">06:00-08:00</div>
                            <div className={"scheduler-item-counter " + (wAv && (wAv[3].IsLocked == false) ? "" : " d-none")}>
                                <TicketIcon className="" />
                                <span className="scheduler-item-counter-text">{wAv ? wAv[3].Count : "-"}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="d-flex flex-fill">
                    <div className={"d-flex flex-fill justify-content-center " + (this.state.selectedItemNumber == "5" ? "scheduler-item-selected" : "scheduler-item") + (wAv && (wAv[4].IsLocked == false) ? "" : " scheduler-item-locked")} onClick={this.onClickTimeItem} windownumber="5" starttime="T08:00" stoptime="T10:00">
                        <div className="py-5 d-flex flex-column justify-content-center">
                            <div className="scheduler-item-time-text">08:00-10:00</div>
                            <div className={"scheduler-item-counter " + (wAv && (wAv[4].IsLocked == false) ? "" : " d-none")}>
                                <TicketIcon className="" />
                                <span className="scheduler-item-counter-text">{wAv ? wAv[4].Count : "-"}</span>
                            </div>
                        </div>
                    </div>
                    <div className={"d-flex flex-fill justify-content-center " + (this.state.selectedItemNumber == "6" ? "scheduler-item-selected" : "scheduler-item") + (wAv && (wAv[5].IsLocked == false) ? "" : " scheduler-item-locked")} onClick={this.onClickTimeItem} windownumber="6" starttime="T10:00" stoptime="T12:00">
                        <div className="py-5 d-flex flex-column justify-content-center">
                            <div className="scheduler-item-time-text">10:00-12:00</div>
                            <div className={"scheduler-item-counter " + (wAv && (wAv[5].IsLocked == false) ? "" : " d-none")}>
                                <TicketIcon className="" />
                                <span className="scheduler-item-counter-text">{wAv ? wAv[5].Count : "-"}</span>
                            </div>
                        </div>
                    </div>
                    <div className={"d-flex flex-fill justify-content-center " + (this.state.selectedItemNumber == "7" ? "scheduler-item-selected" : "scheduler-item") + (wAv && (wAv[6].IsLocked == false) ? "" : " scheduler-item-locked")} onClick={this.onClickTimeItem} windownumber="7" starttime="T12:00" stoptime="T14:00">
                        <div className="py-5 d-flex flex-column justify-content-center">
                            <div className="scheduler-item-time-text">12:00-14:00</div>
                            <div className={"scheduler-item-counter " + (wAv && (wAv[6].IsLocked == false) ? "" : " d-none")}>
                                <TicketIcon className="" />
                                <span className="scheduler-item-counter-text">{wAv ? wAv[6].Count : "-"}</span>
                            </div>
                        </div>
                    </div>
                    <div className={"d-flex flex-fill justify-content-center " + (this.state.selectedItemNumber == "8" ? "scheduler-item-selected" : "scheduler-item") + (wAv && (wAv[7].IsLocked == false) ? "" : " scheduler-item-locked")} onClick={this.onClickTimeItem} windownumber="8" starttime="T14:00" stoptime="T16:00">
                        <div className="py-5 d-flex flex-column justify-content-center">
                            <div className="scheduler-item-time-text">14:00-16:00</div>
                            <div className={"scheduler-item-counter " + (wAv && (wAv[7].IsLocked == false) ? "" : " d-none")}>
                                <TicketIcon className="" />
                                <span className="scheduler-item-counter-text">{wAv ? wAv[7].Count : "-"}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="d-flex flex-fill">
                    <div className={"d-flex flex-fill justify-content-center " + (this.state.selectedItemNumber == "9" ? "scheduler-item-selected" : "scheduler-item") + (wAv && (wAv[8].IsLocked == false) ? "" : " scheduler-item-locked")} onClick={this.onClickTimeItem} windownumber="9" starttime="T16:00" stoptime="T18:00">
                        <div className="py-5 d-flex flex-column justify-content-center">
                            <div className="scheduler-item-time-text">16:00-18:00</div>
                            <div className={"scheduler-item-counter " + (wAv && (wAv[8].IsLocked == false) ? "" : " d-none")}>
                                <TicketIcon className="" />
                                <span className="scheduler-item-counter-text">{wAv ? wAv[8].Count : "-"}</span>
                            </div>
                        </div>
                    </div>
                    <div className={"d-flex flex-fill justify-content-center " + (this.state.selectedItemNumber == "10" ? "scheduler-item-selected" : "scheduler-item") + (wAv && (wAv[9].IsLocked == false) ? "" : " scheduler-item-locked")} onClick={this.onClickTimeItem} windownumber="10" starttime="T18:00" stoptime="T20:00">
                        <div className="py-5 d-flex flex-column justify-content-center">
                            <div className="scheduler-item-time-text">18:00-20:00</div>
                            <div className={"scheduler-item-counter " + (wAv && (wAv[9].IsLocked == false) ? "" : " d-none")}>
                                <TicketIcon className="" />
                                <span className="scheduler-item-counter-text">{wAv ? wAv[9].Count : "-"}</span>
                            </div>
                        </div>
                    </div>
                    <div className={"d-flex flex-fill justify-content-center " + (this.state.selectedItemNumber == "11" ? "scheduler-item-selected" : "scheduler-item") + (wAv && (wAv[10].IsLocked == false) ? "" : " scheduler-item-locked")} onClick={this.onClickTimeItem} windownumber="11" starttime="T20:00" stoptime="T22:00">
                        <div className="py-5 d-flex flex-column justify-content-center">
                            <div className="scheduler-item-time-text">20:00-22:00</div>
                            <div className={"scheduler-item-counter " + (wAv && (wAv[10].IsLocked == false) ? "" : " d-none")}>
                                <TicketIcon className="" />
                                <span className="scheduler-item-counter-text">{wAv ? wAv[10].Count : "-"}</span>
                            </div>
                        </div>
                    </div>
                    <div className={"d-flex flex-fill justify-content-center " + (this.state.selectedItemNumber == "12" ? "scheduler-item-selected" : "scheduler-item") + (wAv && (wAv[11].IsLocked == false) ? "" : " scheduler-item-locked")} onClick={this.onClickTimeItem} windownumber="12" starttime="T22:00" stoptime="T24:00">
                        <div className="py-5 d-flex flex-column justify-content-center">
                            <div className="scheduler-item-time-text">22:00-24:00</div>
                            <div className={"scheduler-item-counter " + (wAv && (wAv[11].IsLocked == false) ? "" : " d-none")}>
                                <TicketIcon className="" />
                                <span className="scheduler-item-counter-text">{wAv ? wAv[11].Count : "-"}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

function withMyHook(Component) {
    return function WrappedComponent(props) {
        const { t } = useTranslation();
        return <Component {...props} t={t } />;
    }
}

export default withMyHook(Scheduler)